// import 'bootstrap/dist/css/bootstrap.css';
import './styles.js';
import './../modules/system/assets/js/framework.js';
import './../plugins/lovata/shopaholic/assets/js/main.js';
import './../plugins/lovata/filtershopaholic/assets/js/main.js';
import './../modules/system/assets/js/framework.js';

import './common/assets/vendors';
import './common/modules';
import './common/modules/select-custom/SelectCustom.js';
import './common/modules/modal/ModalBindings.js';
import './common/modules/form-search/Filter.js';
import './common/modules/search-area/GlobalSearch.js';

//libs
import './common/assets/libs/jquery-details/jquery.details.js';
import './common/assets/libs/masked-input-plugin/masked-input-plugin';
import './common/modules/nice-select/jquery.nice-select.min.js';
import './common/assets/libs/object-fit-polyfill/object-fit-polyfill';
import './common/assets/libs/details-polyfill/index';

//common
import './mainConfig';
import './common/assets/js/validation';
import './common/assets/js/inputMask';
import './common/assets/js/common';
import '../src/common/modules/text-field/search';

import './pages/product/product';
import './pages/orders/Orders';
import './pages/cart/Cart';
import './common/modules/infinity-scroll/infinity-scroll';



$('select').niceSelect();
$('details').details();


/**
 * Add max func to Array
 */
Array.prototype.max = function() {
    return Math.max.apply(null, this);
};


//init header js
import Header from './common/modules/header/header';
if($('.header').length > 0) {
    Header.init();
}


import Rating from './common/modules/star-rating-static/Rating.js';
if ($('.js-rate').length > 0) {

    new Rating($('.js-rate'), {
        count: 5,
        defaultClass: 'star-rating-static__item',
        activeClass:  'star-rating-static__item_selected',
        hoverClass: 'star-rating-static__item_hover'
    });
}

if ($('.product-br-stars').length > 0) {
    $('.product-br-stars').each(function () {
        let _this = $( this );
        let ratingVal = _this.data('rating');
        if (ratingVal <= 20) {
            _this.find('.product-br-star-one:nth-child(1) span').css('width', ratingVal * 5 + '%');
        } else if (ratingVal <= 40) {
            _this.find('.product-br-star-one:nth-child(-n + 1) span').css('width', '100%');
            _this.find('.product-br-star-one:nth-child(2) span').css('width', (ratingVal - 20) * 5  + '%');
        } else if (ratingVal <= 60) {
            _this.find('.product-br-star-one:nth-child(-n + 2) span').css('width', '100%');
            _this.find('.product-br-star-one:nth-child(3) span').css('width', (ratingVal - 40) * 5 + '%');
        } else if (ratingVal <= 80) {
            _this.find('.product-br-star-one:nth-child(-n + 3) span').css('width', '100%');
            _this.find('.product-br-star-one:nth-child(4) span').css('width', (ratingVal - 60) * 5 + '%');
        } else if (ratingVal <= 100) {
            _this.find('.product-br-star-one:nth-child(-n + 4) span').css('width', '100%');
            _this.find('.product-br-star-one:nth-child(5) span').css('width', (ratingVal - 80) * 5 + '%');
        }
    });
}

//init preloader
import PreloaderOverlay from './common/modules/preloader-overlay/preloader-overlay';

//add rent point page  yandex map init
import AddRentPoint from './pages/account-rent-points-create/AddRentPoint.js';
if($('#add-point-map').length > 0) {
    AddRentPoint.mapInit();
}

//create commodity offer step 2
import CommodityOfferCreate from './common/modules/add-commodity-offer-form/add-commodity-offer-form';
if($('.js-offerForm').length > 0) {
    CommodityOfferCreate.init();
}

//account catalog search/filter
import CatalogSearchFilter from './common/modules/catalog-search-filter/catalog-search-filter';
if($('.js-catalogSearchForm').length > 0) {
    CatalogSearchFilter.init();
}

//account catalog table
import CatalogTable from './common/modules/catalog-table/catalog-table';
if($('.js-catalogTable').length > 0) {
    CatalogTable.init();
}

//catalog navigation
import CatalogNav from './common/modules/catalog-navigation/catalog-navigation';
if($('.modal .catalog-navigation').length > 0) {
    CatalogNav.init();
}

//catalog navigation mobile
import CatalogNavMobile from './common/modules/mobile-category/mobile-category';
if($('.modal._mobile').length > 0) {
    CatalogNavMobile.init();
}


//account catalog table
import GroupActions from './common/modules/group-actions/group-actions';
if($('.js-groupActions').length > 0) {
    GroupActions.init();
}

//goods page, goods description block
import ProductDescription from './common/modules/product-description/product-description';
if($('.js-smoth-scroll').length > 0) {
    ProductDescription.init();
}

//create new offer 1st step
import AddOffer from './common/modules/add-offer/add-offer';
if($('.js-addOfferPopup').length > 0) {
    AddOffer.init();
}

//user profile page
import AccountProfile from './pages/account-profile/account-profile';
if($('.account-form_profile').length > 0) {
    AccountProfile.init();
}

//registration
import Registration from './pages/registration/registration';
if($('.account-form_registration').length > 0) {
    Registration.init();
}

//authorization
import Authorization from './pages/authorization/authorization';
if($('.account-form_authorization').length > 0) {
    Authorization.init();
}

//password-restore
import PasswordRestore from './pages/password-restore/password-restore';
if($('.account-form_password-restore').length > 0) {
    PasswordRestore.init();
}

//password change page
import AccountPasswordChange from './pages/account-password-change/account-password-change';
if($('.account-form_password-change').length > 0) {
    AccountPasswordChange.init();
}

//form ask for call
import FormAskForCall from './common/modules/form-ask-for-call/form-ask-for-call';
if($('.form-ask-for-call').length > 0) {
    FormAskForCall.init();
}

//form ask for call mobile
import FormAskForCallMobile from './common/modules/mobile-menu/mobile-menu';
if($('.mobile-menu__ask-for-call').length > 0) {
    FormAskForCallMobile.init();
}

//product offers catalog
import ProductOffers from './common/modules/product-offers/product-offers';
if($('.product-offers').length > 0) {
    ProductOffers.init();
}
//received orders
import ReceivedOrder from './common/modules/received-order/received-order';
if($('.js-receivedOrder').length > 0) {
    ReceivedOrder.init();
}

import MapPopUp from './common/modules/map-pop-up/MapPopUp';
MapPopUp.popUpHandler();

import DataSortCatalog from './common/modules/data-sorter/DataSortCatalog';
DataSortCatalog.setHandlers();

import Time from './common/modules/time/time';

window.$ = $;
window.jQuery = $;



// WEBPACK FOOTER //
// ./src/index.js